<template>
    <div class="qsy-container">
        <div class="qsy-content">
            <!-- 返回首页按钮 -->
            <div class="header-section">
                <el-button type="text" @click="goHome" class="back-home-btn">
                    <i class="el-icon-arrow-left"></i>
                    返回首页
                </el-button>
            </div>
            <!-- 输入区域 -->
            <div class="input-section">
                <el-input v-model="qsyurl" type="textarea" :rows="3" placeholder="请复制平台链接粘贴至此" clearable
                    class="url-input">
                </el-input>
                <div class="input-actions">
                    <div class="action-item" @click="paste">
                        <i class="el-icon-document"></i>
                        <span>粘贴内容</span>
                    </div>
                    <div class="divider"></div>
                    <div class="action-item" @click="qsyurl = ''">
                        <i class="el-icon-close"></i>
                        <span>清空</span>
                    </div>
                </div>
            </div>

            <!-- 开始按钮 -->
            <div class="button-section">
                <el-button type="primary" @click="tishi !== 'agree' ? (tishi = true) : qsy()" style="width: 100%;">
                    立即开始
                </el-button>
            </div>

            <!-- 提取结果 -->
            <div v-if="list.playAddr || list.pics" class="result-section">
                <!-- 标题 -->
                <div class="title-section" @click="copyTitle">
                    <div class="section-label">
                        标题 (点击复制)
                    </div>
                    <div class="title-content">
                        {{ list.desc }}
                    </div>
                </div>

                <!-- 视频和封面 -->
                <div v-if="list.playAddr" class="media-section">
                    <div class="media-item">
                        <el-image :src="list.cover" fit="cover" class="cover-image" @click="previewCover">
                            <div slot="error" class="image-error">
                                <i class="el-icon-picture"></i>
                            </div>
                        </el-image>
                        <div class="media-actions">
                            <el-button type="primary" size="small" @click="downloadImage(list.cover, '封面')">
                                下载封面
                            </el-button>
                            <div class="copy-link" @click="_copy(list.cover)">
                                复制封面链接
                            </div>
                        </div>
                    </div>
                    <div class="media-item">
                        <video :src="list.playAddr" controls class="video-player">
                        </video>
                        <div class="media-actions">
                            <el-button type="primary" size="small" @click="downloadVideo" :loading="downloading">
                                {{ downloading ? `下载中 ${downloadProgress}%` : '下载视频' }}
                            </el-button>
                            <div class="copy-link" @click="_copy(list.playAddr)">
                                复制视频链接
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 图文列表 -->
                <div v-if="list.pics && list.pics.length > 0" class="pics-section">
                    <div class="section-label">图文列表</div>
                    <div class="pics-grid">
                        <div v-for="(pic, index) in list.pics" :key="index" class="pic-item">
                            <div class="pic-wrapper" @click="previewPics(index)">
                                <el-image :src="pic" fit="cover" class="pic-image">
                                    <div slot="error" class="image-error">
                                        <i class="el-icon-picture"></i>
                                    </div>
                                </el-image>
                            </div>
                            <div class="pic-download-btn" @click.stop="downloadSinglePic(pic, index)">
                                <i class="el-icon-download"></i>
                            </div>
                        </div>
                    </div>
                    <div class="pics-actions">
                        <el-button type="primary" size="small" @click="downloadAllPics">
                            全部下载
                        </el-button>
                    </div>
                </div>
            </div>

            <!-- 使用说明弹窗 -->
            <el-dialog :visible.sync="showTipDialog" title="使用说明" width="500px" :close-on-click-modal="false"
                @close="handleReject">
                <div class="tip-content">
                    <div class="tip-item">此功能免费提供</div>
                    <div class="tip-item">
                        平台作为提供技术的中立工具，此功能仅限帮助用户提取视频自行学习、观看，降低视频、图片浏览障碍
                    </div>
                    <div class="tip-item">
                        <span class="tip-warning">提示：</span>
                        用户请合法使用，若用户滥用该功能实施侵权行为，用户应自行承担由此产生的法律责任。平台倡导与用户共创营造良好网络环境！
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="handleReject">拒绝</el-button>
                    <el-button type="primary" @click="handleAgree">我知道了</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Qsy',
    data() {
        return {
            qsyurl: '',
            list: {},
            tishi: false,
            showTipDialog: false,
            downloading: false,
            downloadProgress: 0,
            downloadTask: null
        }
    },
    methods: {
        async paste() {
            try {
                const text = await navigator.clipboard.readText();
                this.qsyurl = text;
                this.$message.success('粘贴成功');
            } catch (err) {
                this.$message.error('粘贴失败，请手动输入');
            }
        },
        qsy() {
            if (!this.qsyurl.trim()) {
                this.$message.warning('请输入链接');
                return;
            }

            const loading = this.$loading(this.$loadinginfo);
            const data = {
                url: this.qsyurl
            }

            this.$ajax.post('qhy/user/qsyjk', data, {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }).then(res => {
                console.log(res.data)
                if (res.data.status == 200) {
                    this.list = res.data.data || {}
                } else {
                    this.$message.error(res.data.msg);
                    this.list = {}
                }
                loading.close();
            }).catch(err => {
                console.error('提取失败:', err)
                this.$message.error('提取失败，请稍后重试');
                loading.close();
            })
        },
        handleAgree() {
            this.tishi = 'agree';
            this.showTipDialog = false;
            this.qsy();
        },
        handleReject() {
            this.tishi = false;
            this.showTipDialog = false;
        },
        copyTitle() {
            if (this.list.desc) {
                this._copy(this.list.desc);
            }
        },
        _copy(context) {
            if (!context) {
                this.$message.warning('没有可复制的内容');
                return;
            }
            try {
                // 使用现代 Clipboard API
                if (navigator.clipboard && navigator.clipboard.writeText) {
                    navigator.clipboard.writeText(context).then(() => {
                        this.$message.success('复制成功');
                    }).catch(() => {
                        this.fallbackCopy(context);
                    });
                } else {
                    this.fallbackCopy(context);
                }
            } catch (e) {
                this.fallbackCopy(context);
            }
        },
        fallbackCopy(text) {
            try {
                let oInput = document.createElement('textarea');
                oInput.value = text;
                oInput.style.position = 'fixed';
                oInput.style.opacity = '0';
                document.body.appendChild(oInput);
                oInput.select();
                document.execCommand('Copy');
                this.$message.success('复制成功');
                oInput.remove();
            } catch (e) {
                this.$message.error('复制失败');
            }
        },
        previewCover() {
            if (this.list.cover) {
                window.open(this.list.cover, '_blank');
            }
        },
        previewPics(index) {
            if (this.list.pics && this.list.pics.length > 0) {
                // 可以集成图片预览组件
                window.open(this.list.pics[index], '_blank');
            }
        },
        async downloadImage(url, name, silent = false) {
            if (!url) {
                if (!silent) {
                    this.$message.warning('图片链接不存在');
                }
                return false;
            }

            try {
                // 尝试使用 fetch 下载（支持跨域需要服务器支持 CORS）
                const response = await fetch(url, {
                    method: 'GET',
                    mode: 'cors'
                });

                if (!response.ok) {
                    throw new Error('下载失败');
                }

                const blob = await response.blob();
                const blobUrl = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = blobUrl;
                link.download = name || 'image.jpg';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(blobUrl);
                if (!silent) {
                    this.$message.success('下载成功');
                }
                return true;
            } catch (error) {
                console.error('下载失败:', error);
                // 如果 fetch 失败，尝试直接下载
                try {
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = name || 'image.jpg';
                    link.target = '_blank';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    // 延迟提示（无法准确检测是否真的下载了）
                    if (!silent) {
                        setTimeout(() => {
                            this.$message({
                                message: '如果下载失败，请右键图片选择"另存为"',
                                type: 'warning',
                                duration: 5000,
                                showClose: true
                            });
                        }, 500);
                    }
                    // 返回不确定状态，因为无法准确检测
                    return true;
                } catch (e) {
                    // 如果都失败了，提示用户手动保存
                    if (!silent) {
                        this.$message({
                            message: '自动下载失败，请右键图片选择"另存为"进行保存',
                            type: 'warning',
                            duration: 6000,
                            showClose: true
                        });
                    }
                    return false;
                }
            }
        },
        downloadSinglePic(url, index) {
            this.downloadImage(url, `图片${index + 1}.jpg`);
        },
        downloadVideo() {
            if (!this.list.playAddr) {
                this.$message.warning('视频链接不存在');
                return;
            }
            // Web端下载视频
            const link = document.createElement('a');
            link.href = this.list.playAddr;
            link.download = 'video.mp4';
            link.target = '_blank';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.$message.success('开始下载');
        },
        async downloadAllPics() {
            if (!this.list.pics || this.list.pics.length === 0) {
                this.$message.warning('没有图片可下载');
                return;
            }

            this.$message.info(`开始下载 ${this.list.pics.length} 张图片，请稍候...`);

            let successCount = 0;
            let failCount = 0;

            for (let i = 0; i < this.list.pics.length; i++) {
                const result = await this.downloadImage(this.list.pics[i], `图片${i + 1}.jpg`, true);
                if (result) {
                    successCount++;
                } else {
                    failCount++;
                }
                // 延迟避免浏览器限制
                if (i < this.list.pics.length - 1) {
                    await new Promise(resolve => setTimeout(resolve, 300));
                }
            }

            if (failCount > 0) {
                this.$message({
                    message: `下载完成：成功 ${successCount} 张，失败 ${failCount} 张。失败的图片请右键选择"另存为"`,
                    type: failCount === this.list.pics.length ? 'warning' : 'info',
                    duration: 6000,
                    showClose: true
                });
            } else {
                this.$message.success(`成功下载 ${successCount} 张图片`);
            }
        },
        goHome() {
            this.$router.push({ path: "/user/index" });
        }
    },
    watch: {
        tishi(newVal) {
            if (newVal === true) {
                this.showTipDialog = true;
            }
        }
    }
}
</script>

<style scoped>
.qsy-container {
    display: flex;
    justify-content: center;
    min-height: calc(100vh - 100px);
    background-color: #f6f7f8;
}

.qsy-content {
    max-width: 800px;
    width: 100%;
    margin-top: 10px;
}

.header-section {
    margin-bottom: 20px;
}

.back-home-btn {
    padding: 0;
    font-size: 14px;
    color: #606266;
}

.back-home-btn:hover {
    color: #409eff;
}

.back-home-btn i {
    margin-right: 5px;
}

.input-section {
    background-color: #fff;
    padding: 20px;
    border-radius: 10px;
    margin-bottom: 20px;
}

.url-input {
    margin-bottom: 15px;
}

.input-actions {
    display: flex;
    align-items: center;
    font-size: 13px;
}

.action-item {
    display: flex;
    align-items: center;
    cursor: pointer;
    color: #606266;
    transition: color 0.3s;
}

.action-item:hover {
    color: #409eff;
}

.action-item i {
    margin-right: 1px;
    font-size: 16px;
}

.divider {
    width: 1px;
    height: 15px;
    background-color: #adadad;
    margin: 0 15px;
}

.button-section {
    margin-bottom: 20px;
}

.result-section {
    background-color: #fff;
    padding: 20px;
    border-radius: 10px;
}

.title-section {
    margin-bottom: 20px;
    cursor: pointer;
}

.section-label {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 10px;
}

.title-content {
    font-size: 14px;
    color: #5d5d5d;
    background-color: #f4f4f4;
    padding: 15px;
    border-radius: 8px;
    word-break: break-all;
    line-height: 1.6;
}

.media-section {
    display: flex;
    justify-content: space-between;
    gap: 20px;
    margin-bottom: 20px;
}

.media-item {
    flex: 1;
    display: flex;
    flex-direction: column;
}

.cover-image {
    width: 100%;
    height: 300px;
    border-radius: 8px;
    cursor: pointer;
    background-color: #f5f5f5;
}

.video-player {
    width: 100%;
    height: 300px;
    border-radius: 8px;
    background-color: #000;
}

.media-actions {
    margin-top: 15px;
    text-align: center;
}

.copy-link {
    font-size: 13px;
    color: #535353;
    margin-top: 10px;
    cursor: pointer;
    text-align: center;
}

.copy-link:hover {
    color: #409eff;
}

.pics-section {
    margin-top: 20px;
}

.pics-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 8px;
    margin-top: 10px;
}

.pic-item {
    position: relative;
    overflow: hidden;
    background-color: #f5f5f5;
    border-radius: 8px;
}

.pic-wrapper {
    cursor: pointer;
    width: 100%;
    height: 100%;
}

.pic-download-btn {
    position: absolute;
    top: 5px;
    right: 5px;
    width: 28px;
    height: 28px;
    background-color: rgba(0, 0, 0, 0.6);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #fff;
    font-size: 14px;
    transition: all 0.3s;
    z-index: 10;
}

.pic-download-btn:hover {
    background-color: rgba(64, 158, 255, 0.8);
    transform: scale(1.1);
}

.pic-image {
    width: 100%;
    height: 130px;
    border-radius: 8px;
}

.image-error {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #c0c4cc;
    font-size: 24px;
}

.pics-actions {
    margin-top: 15px;
    text-align: center;
}

.tip-content {
    color: #464646;
    font-size: 14px;
    line-height: 1.8;
}

.tip-item {
    margin-bottom: 15px;
}

.tip-warning {
    color: darkred;
    font-weight: 600;
}

.dialog-footer {
    display: flex;
    justify-content: space-between;
    gap: 10px;
}

.dialog-footer .el-button {
    flex: 1;
}

@media (max-width: 768px) {
    .media-section {
        flex-direction: column;
    }

    .pics-grid {
        grid-template-columns: repeat(2, 1fr);
    }

    .pic-image {
        height: 120px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/User/Qsy.vue


// WEBPACK FOOTER //
// src/components/User/Qsy.vue